import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setApiJson } from '../../redux/Actions/ApiAction';
import { formatTimestampToDate } from '../../utils/utils';

const DatePicker = ({ value, title, name = "scheduledDate", important = false, error = null }) => {
    const dispatch = useDispatch();
    const ApiReducer = useSelector((state) => state.ApiReducer);

    // Get current date value from redux and convert timestamp back to yyyy-MM-dd format
    const getCurrentValue = () => {
        const timestamp = ApiReducer?.apiJson?.[name];
        if (timestamp) {
            const date = new Date(timestamp);
            return date.toISOString().slice(0, 10); // yyyy-MM-dd
        }
        return '';
    };

    const currentValue = getCurrentValue();

    // Get minimum date (today)
    const getMinDate = () => {
        const today = new Date();
        return today.toISOString().slice(0, 10);
    };

    const handleDateChange = (e) => {
        const selectedDate = e.target.value;

        if (selectedDate) {
            const date = new Date(selectedDate);
            // force time to 00:00:00 for consistency
            date.setHours(0, 0, 0, 0);
            const timestamp = date.getTime();

            const updatedJson = {
                ...ApiReducer?.apiJson,
                [name]: timestamp
            };

            dispatch(setApiJson(updatedJson));
        } else {
            // Clear timestamp if input is cleared
            const updatedJson = {
                ...ApiReducer?.apiJson,
                [name]: null
            };

            dispatch(setApiJson(updatedJson));
        }
    };

    console.log('currentValue', currentValue);


    return (
        <div className="flex flex-col">
            {
                title &&
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {title}
                    {important && <span className="text-red-500 ml-1">*</span>}
                </label>
            }

            <input
                type="date"
                name={name}
                value={value ? formatTimestampToDate(value) : currentValue}
                onChange={handleDateChange}
                min={getMinDate()}
                className={`
                    w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                    ${error ? 'border-red-500' : 'border-gray-300'}
                `}
            />

            {error && (
                <span className="text-red-500 text-sm mt-1">{error}</span>
            )}
        </div>
    );
};

export default DatePicker;
